import { FormattedMessage } from "react-intl";
import { nodeShape } from "../../shapes/nodesShape";
import { url } from "../../utils";
import Breadcrumb from "./Breadcrumb";
import BreadcrumbItem from "./BreadcrumbItem";

const buildBreadCrumb = (
  onClick: $TSFixMe,
  node: $TSFixMe,
  current: $TSFixMe,
  prefix: $TSFixMe,
  breadcrumb: $TSFixMe,
) => {
  if (!breadcrumb && current) {
    return buildBreadCrumb(onClick, node, current, prefix, [
      <BreadcrumbItem key={current} title={current} />,
    ]);
  }
  if (node) {
    if (!breadcrumb) {
      return buildBreadCrumb(onClick, node.parent, current, prefix, [
        <BreadcrumbItem key={node.id} title={node.name} />,
      ]);
    }
    const targetUrl = prefix
      ? `${prefix}/nodes/${node.id}`
      : `/nodes/${node.id}`;

    breadcrumb.unshift(
      <BreadcrumbItem
        key={node.id}
        title={node.name}
        onClick={() => onClick(node)}
        target={url(targetUrl)}
      />,
    );

    if (node.parent) {
      buildBreadCrumb(onClick, node.parent, current, prefix, breadcrumb);
    }
  }
  return breadcrumb;
};

type Props = {
  id?: string;
  onClick?: $TSFixMeFunction;
  current?: string;
  node?: nodeShape;
  firstItemTitleId?: string;
  firstItemTargetUrl?: string;
  breadCrumbTargetUrlPrefix?: string;
};

function NestedNodeBreadcrumb({
  id,
  node,
  current,
  onClick,
  firstItemTitleId,
  firstItemTargetUrl,
  breadCrumbTargetUrlPrefix,
}: Props) {
  const firstItemTitle = (
    <FormattedMessage id={firstItemTitleId || "nodes.header"} />
  );
  // @ts-expect-error TS(2554) FIXME: Expected 5 arguments, but got 4.
  const breadcrumb = buildBreadCrumb(
    onClick,
    node,
    current,
    breadCrumbTargetUrlPrefix,
  );

  if (breadcrumb) {
    breadcrumb.unshift(
      <BreadcrumbItem
        key="all"
        title={firstItemTitle}
        // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        onClick={() => onClick()}
        target={url(firstItemTargetUrl)}
      />,
    );
  }

  return node || current ? (
    <Breadcrumb id={id}>{breadcrumb}</Breadcrumb>
  ) : (
    <Breadcrumb id={id}>
      <BreadcrumbItem key="all" title={firstItemTitle} />
    </Breadcrumb>
  );
}

export default NestedNodeBreadcrumb;
